import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import styles from './MarketSegmentCreate.module.css';

const MarketSegmentCreate = () => {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    name: ''
  });
  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState({});

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
    
    // Clear error when user starts typing
    if (errors[name]) {
      setErrors(prev => ({
        ...prev,
        [name]: ''
      }));
    }
  };

  const validateForm = () => {
    const newErrors = {};
    
    if (!formData.name.trim()) {
      newErrors.name = 'The name field is required.';
    } else if (formData.name.length > 255) {
      newErrors.name = 'The name may not be greater than 255 characters.';
    }
    
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!validateForm()) {
      return;
    }
    
    setLoading(true);
    
    try {
      const baseUrl = process.env.REACT_APP_API_URL || 'http://localhost:3001';
      const response = await fetch(`${baseUrl}/api/marketsegments`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${localStorage.getItem('token')}`
        },
        body: JSON.stringify(formData)
      });
      
      if (response.ok) {
        const result = await response.json();
        toast.success('Market segment created successfully!');
        navigate('/market-segments');
      } else {
        const errorData = await response.json();
        if (errorData.errors) {
          setErrors(errorData.errors);
        } else {
          toast.error(errorData.message || 'Failed to create market segment');
        }
      }
    } catch (error) {
      console.error('Error creating market segment:', error);
      toast.error('An error occurred while creating the market segment');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className={styles.container}>
      {/* Breadcrumbs */}
      <nav className={styles.breadcrumbNav}>
        <ol className={styles.breadcrumb}>
          <li><a href="/dashboard">Dashboard</a></li>
          <li><a href="/market-segments">Market Segments</a></li>
          <li className={styles.active}>Create Market Segment</li>
        </ol>
      </nav>

      <div className={styles.row}>
        <div className={styles.colMd12}>
          <div className={`${styles.panel} ${styles.panelForm}`}>
            <div className={styles.panelHeading}>
              <div className={styles.panelTitle}>
                <h3>Create Market Segment</h3>
              </div>
            </div>
            <div className={styles.panelBody}>
              <form onSubmit={handleSubmit} className={styles.formHorizontal}>
                <fieldset className={styles.formHorizontal}>
                  <div className={styles.formGroup}>
                    <label htmlFor="name" className={`${styles.controlLabel} ${styles.colSm3}`}>
                      Name <span className={styles.textDanger}>*</span>
                    </label>
                    <div className={styles.colSm5}>
                      <input
                        type="text"
                        className={`${styles.formControl} ${errors.name ? styles.isInvalid : ''}`}
                        id="name"
                        name="name"
                        value={formData.name}
                        onChange={handleInputChange}
                        placeholder="Enter market segment name"
                        maxLength={255}
                        required
                      />
                      {errors.name && (
                        <div className={styles.invalidFeedback}>
                          {errors.name}
                        </div>
                      )}
                    </div>
                  </div>
                </fieldset>

                <fieldset className={styles.formHorizontal}>
                  <div className={`${styles.formGroup} ${styles.textRight}`}>
                    <div className={styles.colSm12}>
                      <button
                        type="submit"
                        className={`${styles.btn} ${styles.btnHead} ${styles.btnStandard}`}
                        disabled={loading}
                      >
                        {loading ? 'Creating...' : 'Create'}
                      </button>
                    </div>
                  </div>
                </fieldset>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MarketSegmentCreate; 